<template>
    <div class="ui-wrapper">

        <!-- Buttons -->
        <div class="ui-content">
            <label>Buttons</label>
            <br />
            <vue-button color="primary">Click Me!</vue-button>
            <vue-button color="link">Click Me!</vue-button>
            <!-- <vue-button color="primary" round>+</vue-button> -->
        </div>

        <!-- Search -->
        <div class="ui-content">
            <label>Inputs</label>
            <br />
            <vue-search
                :keyword="searchKeyword"
                @onEnter="search"
            />

            <vue-checkbox />
        </div>

        <!-- Boxes Wrapper/Card -->
        <div class="ui-content">
            <label>Boxes / Card</label>
            <br />
            <vue-box>
                Some content goes here!!!
            </vue-box>
        </div>

        <!-- Headings -->
        <div class="ui-content">
            <label>Headings</label>
            <br />
            <vue-heading :size="1">heading size 1</vue-heading>
            <vue-heading :size="2">heading size 2</vue-heading>
            <vue-heading :size="3">heading size 3</vue-heading>
        </div>

        <div class="ui-content">
            <label>Headings</label>
            <br />
            <vue-accordian
                title="Order Summary"
            >
                content
            </vue-accordian>
        </div>

        <div class="ui-content">
            <label>Headings</label>
            <br />
            <vue-alert>alert box</vue-alert>
        </div>


        <div class="ui-content">
            <h1>Inputs</h1>
            <vue-input
                label="Some Label"
                error="error message here"
            />
        </div>


        <br /><br /><br />
        <h1>Base Component</h1>
        <vue-base-password v-model="password"></vue-base-password>
    </div>
</template>

<script>
export default {
    name: 'UI',
    data() {
        return {
            searchKeyword: 'John Doe',
            password: 'password',
        };
    },
    methods: {
        search() {
        },
    },
};
</script>

<style scoped lang="scss">
.ui-wrapper {
    height: 5000px;
}
.ui-content {
    margin: 10px;
    padding: 10px;
    margin-bottom: 150px;

    label {
        font-size: 20px;
        display: block;
        margin-bottom: 10px;
    }
}
</style>
